import { render, staticRenderFns } from "./kbbb.vue?vue&type=template&id=695e1786&"
import script from "./kbbb.vue?vue&type=script&lang=js&"
export * from "./kbbb.vue?vue&type=script&lang=js&"
import style0 from "./kbbb.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports